import EcomService from '@root/commonvue/EcomService.js';

export default {
    namespaced: true,
    state: {
        product: null,
        cart: [],
        showProductPrice: true,
        shareOwners: [],
    },
    getters: {
        EcomService: () => EcomService,
        product: (state) => state.product || {},
        showProductPrice: (state) => state.showProductPrice,
        cartIsPopulated(state) {
            return state.cart.length > 0;
        },
        cartHasReservations(state) {
            return state.cart.filter((row) => row.type === 6).length > 0;
        },
        orderLinkUrl: (state) => (orderId, hash = null) => {
            const urlPieces = location.host.split('.');

            if (hash === null) {
                if (urlPieces.length === 2) {
                    urlPieces.unshift('admin');
                } else {
                    urlPieces[0] = 'admin';
                }
    
                return `${ location.protocol }//${ urlPieces.join('.') }/?action=orders&subact=view&orderid=${ orderId }`
            }
            
            return `${ location.protocol }//${ urlPieces.join('.') }/?action=customeraccount&method=vieworder&orderid=${ orderId }&hashid=${ hash }`
        },
        shareOwners: (state) => state.shareOwners,
    },
    mutations: {
        setCart(state, rows) {
            state.cart = rows;
        },
    },
    actions: {
        getProductInfo({ state }, productId) {
            return EcomService.getProductInfo(productId)
            .then((response) => {
                const { data } = response;
        
                if (typeof data.rows[0] !== 'undefined') {
                    const product = data.rows[0];
                    product.price = -(-product.price);

                    if (product.price === 0) {
                        state.showProductPrice = false;
                    }

                    if (typeof product.images === 'string' && product.images.length > 0) {
                        // service urls??
                        product.images = product.images.split(',').map((id) => `/?action=getContent&type=img&id=${ id }`)
                    }

                    state.product = product;
                }
                return response;
            })
        },
        getMyCart({ state }) {
            return EcomService.getMyCart()
            .then(response => {
                const { data } = response;
                
                if (Array.isArray(data.rows)) {
                    state.cart = data.rows;
                }
                
                return response;
            })
        },
        deleteCartOrder({ state, dispatch }) {
            return Promise.all([
                EcomService.deleteCartOrder(),
                ...state.cart.map(product => EcomService.removeFromCart(product.cartProductId))
            ])
        },
        getShareOwners({ state }) {
            if (state.shareOwners.length > 0) {
                // mimic ajax response
                return Promise.resolve({
                    data: {
                        rows: state.shareOwners
                    }
                })
            }

            return EcomService.getShareOwners()
            .then(response => {
                const { data } = response;
                
                if (Array.isArray(data.rows)) {
                    state.shareOwners = data.rows;
                }
                
                return response;
            })
        },
    }
}